import React from "react";
import Select from "../../../../../components/atoms/Select";

interface PageSelectProps {
  value: number;
  onPageSizeChanged: (pageSize: number) => void;
}

const PageSelect: React.FC<PageSelectProps> = (props) => {
  const { value, onPageSizeChanged } = props;
  return (
    <div style={{ width: "72px" }}>
      <Select
        onChange={(e) => onPageSizeChanged(e)}
        value={value}
        options={[
          { label: "10", value: 10 },
          { label: "20", value: 20 },
          { label: "30", value: 30 },
        ]}
      />
    </div>
  );
};
export default PageSelect;
